import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_NEXT_NUMBER_ORDER_OF_CANDIDATE } from "../Schema/Candidate";

export const useGetNextNumberOrderOfCandidate = ({
  candidateType,
  partyId,
  setFieldValue,
  dialogTitle,
}) => {
  const { refetch } = useQuery(GET_NEXT_NUMBER_ORDER_OF_CANDIDATE, {
    variables: {
      partyId: partyId || "",
      candidateType: candidateType || "",
    },
    onCompleted: ({ getNextNumberOrderOfCandidate }) => {
      if (dialogTitle === "Create")
        setFieldValue("numberOrder", getNextNumberOrderOfCandidate);
    },
  });
  useEffect(() => {
    refetch();
  }, [partyId, candidateType]);

  return { refetch };
};
